export default __webpack_public_path__ + "static/media/location.6afb2342.svg";